var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'my-alert-border':true,center:(_vm.type==='center'),end:(_vm.type==='end')}},[_c('div',{staticClass:"my-alert",style:({opacity:_vm.thisOpacity})},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }